// extracted by mini-css-extract-plugin
export default {"title":"AppTitle_title__uVoqn"};